import lazyframe from "lazyframe";

export default () => {
  let elements = $(".video-player__lazyframe");
  let sliderViewport = $(".js-efficiency-slider-viewport");

  lazyframe(elements, {
    onAppend: iframe => {
      $(iframe).attr({
        allow: "autoplay",
        title: elements.data( "title")
      });
      if (sliderViewport.length) {
        sliderViewport.slick("slickPause");
        sliderViewport.addClass("js-player-is-on")
      }
    }
  });

  $(elements).on("keydown", function (event) {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode === 13) {
      $(this).trigger("click");
    }
  });
};
